import * as reactDom from 'react-dom';
import * as reactRouterDom from 'react-router-dom';
import * as reactRouterDomV6 from 'react-router-dom-v6';
import * as propTypes from 'prop-types';
import * as styledComponents from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import * as fluentuiReact from '@fluentui/react';
import * as reactUse from 'react-use';
import * as Select from 'react-select';
import * as AsyncSelect from 'react-select/async';
import * as CreatableSelect from 'react-select/creatable';
import SplitPane from 'react-split-pane/lib/SplitPane';
import Pane from 'react-split-pane/lib/Pane';
import * as skyjsDate from '@skyjs/date';
import * as skyjsLang from '@skyjs/lang';
import * as skyjsLodashExtras from '@skyjs/lodash-extras';
import * as skyjsUrl from '@skyjs/url';
import * as framerMotion from 'framer-motion';
import * as reactToastify from 'react-toastify';
import * as reactHelmet from 'react-helmet';
import * as recoil from 'recoil';
import * as jotai from 'jotai';
import * as jotaiUtils from 'jotai/utils';

SplitPane.Pane = Pane;

const ReactBeautifulDnd = () => import('react-beautiful-dnd');
ReactBeautifulDnd.isAsync = true;

const FroalaEditor = async () => {
  const Editor = await import('./froala-editor.js');
  return Editor.default;
};
FroalaEditor.isAsync = true;

const ReactFroalaWysiwyg = () => import('react-froala-wysiwyg');
ReactFroalaWysiwyg.isAsync = true;

const reactMarkdown = () => import('react-markdown');
reactMarkdown.isAsync = true;

const remarkGfm = () => import('remark-gfm');
remarkGfm.isAsync = true;

const recharts = () => import('recharts');
recharts.isAsync = true;

const MonacoEditor = () => import('@monaco-editor/react');
MonacoEditor.isAsync = true;

function makeESModule(dep) {
  const modifiedDep = { ...dep };
  Object.defineProperty(modifiedDep, '__esModule', { value: true });
  return modifiedDep;
}

export default {
  '@skyjs/date': skyjsDate,
  '@skyjs/lang': skyjsLang,
  '@skyjs/lodash-extras': skyjsLodashExtras,
  '@skyjs/url': skyjsUrl,
  '@fluentui/react': fluentuiReact,
  axios,
  'framer-motion': framerMotion,
  'froala-editor': FroalaEditor,
  'office-ui-fabric-react': fluentuiReact,
  'prop-types': propTypes,
  'react-beautiful-dnd': ReactBeautifulDnd,
  'react-dom': reactDom,
  'react-froala-wysiwyg': ReactFroalaWysiwyg,
  recharts,
  'react-markdown': reactMarkdown,
  'remark-gfm': remarkGfm,
  'react-router-dom': reactRouterDom,
  'react-router-dom-v6': reactRouterDomV6,
  'react-select': makeESModule(Select),
  'react-select/async': makeESModule(AsyncSelect),
  'react-select/creatable': makeESModule(CreatableSelect),
  'react-split-pane': SplitPane,
  'react-toastify': reactToastify,
  'react-helmet': reactHelmet,
  recoil,
  jotai,
  'jotai/utils': jotaiUtils,
  'react-use': reactUse,
  'styled-components': makeESModule(styledComponents),
  '@monaco-editor/react': MonacoEditor,
  uuid: uuidv4
};
